import { getSectionData } from "../utilities/getSectionData";
import { _addEventListener } from "../utilities/Helpers/eventHelper";
import Modal from "../utilities/Helpers/UI/Modal";

LUC.jsHeader = {
    searchEventHandlers() {
        const searchOverlayClose = document.querySelector(".search-overlay__close");
        const searchShowTriggers = document.querySelectorAll("[data-show-search-trigger]");
        const boostSearchCloseSuggestionBtn = document.querySelector(".boost-pfs-search-btn-close-suggestion");

        _addEventListener(searchOverlayClose, "click", LUC.jsHeader.hideSearch);

        searchShowTriggers.forEach((searchShowTrigger) => {
            _addEventListener(searchShowTrigger, "click", LUC.jsHeader.showSearch);
            _addEventListener(searchShowTrigger, "click", () =>
                $(".boost-pfs-search-suggestion-mobile-top-panel").show()
            );
            _addEventListener(searchShowTrigger, "keydown", (e) => {
                if (e.which === 13) {
                    LUC.jsHeader.showSearch();
                }
            });
        });

        _addEventListener(boostSearchCloseSuggestionBtn, "click", () => {
            $(".search-overlay__close").click();
        });
    },
    init: function ($section) {
        // New Navigattion Tabs Action Desktop
        let isOS = navigator.appVersion.indexOf("Mac") != -1;
        if (isOS) {
            //TODO: not related to header
            $("body").addClass("mac");
        }

        // Sticky header
        this.searchEventHandlers();
    },
    showSearch: function () {
        if (window.gtag) {
            gtag("event", "search_icon_click", { search_engine: "old" });
        }
        Modal.getModalByName("search").show();
        $('.search-form .search__fields input[type="text"]').focus();
    },
    hideSearch: function () {
        $("[data-show-search-trigger]").removeClass("is-active");

        $('[data-search-type="overlay"]').removeClass("is-opened");
    },
    getHeaderHeight: function () {
        return $(".header-section").outerHeight() || 0;
    },
    unload: function ($section) {},
};
